/**
 * Dependencies
 */
import http from '../../../services/HttpService'

/**
 * Profile URL
 *
 * @type {String}
 */
const PROFILE_URL = 'auth/user-info/'

/**
 * Get the user profile
 *
 * @param  {Function} options.commit
 * @return {Void}
 */
const getProfile = ({ commit }) => {
    return new Promise((resolve, reject) => {
        commit('SET_LOADING')
        http.get(PROFILE_URL)
            .then(res => {
                commit('SET_PROFILE_SUCCESS', res.data)
                commit('RESET_LOADING')
                resolve(res.data)
            })
            .catch(err => {
                commit('SET_PROFILE_FAILURE', err.response.data)
                reject(err)
            })
    })
}

/**
 * Update the user profile
 *
 * @param  {Function} options.commit
 * @param  {Object} profile
 * @return {Void}
 */
const updateProfile = ({ commit, dispatch }, profile) => {
    commit('SET_LOADING')
    http.patch(PROFILE_URL, profile)
        .then(res => {
            commit('SET_MESSAGE', res.data.message)
            commit('SET_PROFILE_SUCCESS', profile)
            dispatch('user/getUserProfile', null, { root: true })
            commit('RESET_LOADING')
        })
        .catch(err => {
            commit('SET_PROFILE_FAILURE', err.response.data.message)
            commit('RESET_LOADING')
        })
}

/**
 * Reset message
 *
 * @param  {Function} options.commit
 * @return {Promise}
 */
const resetMessage = ({ commit }) => commit('RESET_MESSAGE')

export default {
    getProfile,
    resetMessage,
    updateProfile
}



// WEBPACK FOOTER //
// ./src/state/modules/profile/actions.js